<!-- <div class="summary card bb-panel"> -->
<!-- <div>
        <img src="{{selectedService?.image?.url}}" alt="service image" class="service-image" />
    </div> -->
<!-- <div class="heading-section">
        <h2 tabindex="0" aria-label="your booking summary">{{ 'FORM.SUMMARY.YOUR_BOOKING' | translate }}</h2>
    </div>
    <div class="summary-content">
        <p *ngIf="translateService.currentLang == 'en'" tabindex="0" class="summary-content-header">
            {{selectedService?.name}}</p>
        <p *ngIf="translateService.currentLang == 'cy'" tabindex="0" class="summary-content-header">
            {{selectedService?.extra?.service_name_welsh}}</p>
        <p tabindex="0" *ngIf="selectedService?.price > 0" class="summary-content-header"> £{{selectedService?.price
            /100}}</p>
        <p tabindex="0" *ngIf="selectedSlot" class="summary-content-header pb-0">{{selectedSlot?.start | date: 'EEEE d
            MMMM yyyy' : '' : this.translateService.currentLang}}</p>
        <p tabindex="0" *ngIf="selectedSlot" class="pb-3">{{selectedSlot?.start | date: 'HH:mm'}}</p>

        <p *ngIf="translateService.currentLang == 'en'" tabindex="0" aria-label="selected location"
            class="summary-content-header pb-0">{{selectedLocation?.name}}</p>
        <p *ngIf="translateService.currentLang == 'cy'" tabindex="0" aria-label="selected location"
            class="summary-content-header pb-0">{{selectedLocation?.extra?.location_name_welsh}}</p>
        <div *ngIf="translateService.currentLang == 'en'">
            <p tabindex="0">{{address?.address.address1}}</p>
            <p tabindex="0">{{address?.address.address2}}</p>
            <p tabindex="0">{{address?.address.address4}}</p>
            <p tabindex="0">{{address?.address.address5}}</p>
            <p tabindex="0">{{address?.address.postcode}}</p>
        </div>
        <div *ngIf="translateService.currentLang == 'cy'">
            <span *ngIf="selectedLocation?.extra?.location_address_welsh"
                [innerHTML]="selectedLocation?.extra?.location_address_welsh | lineSplit"></span>
        </div>

    </div>
</div> -->

<div class="govuk-summary-card">
  <div class="govuk-summary-card__title-wrapper">
    <h2 class="govuk-summary-card__title">
      {{ 'FORM.SUMMARY.YOUR_BOOKING' | translate }}
    </h2>
  </div>
  <div class="govuk-summary-card__content">
    <dl class="govuk-summary-list">
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Service</dt>
        <dd class="govuk-summary-list__value">
          {{ selectedService?.name }}
        </dd>
      </div>

      <div *ngIf="selectedService?.price > 0" class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Price</dt>
        <dd class="govuk-summary-list__value">
          £{{ selectedService?.price / 100 }}
        </dd>
      </div>

      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Time</dt>
        <dd class="govuk-summary-list__value">
          {{ selectedSlot?.displayTime}}
        </dd>
      </div>

      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Date</dt>
        <dd class="govuk-summary-list__value">
          {{
          selectedSlot?.start
          | date
          : 'EEEE d MMMM yyyy'
          : ''
          : this.translateService.currentLang
          }}
        </dd>
      </div>
      <!-- 
             <div class="govuk-summary-list__row">
                <dt class="govuk-summary-list__key">
                    Location
                </dt>
                <dd class="govuk-summary-list__value">
                    {{selectedLocation?.name}}
                </dd>
            </div>
             -->

      <div class="govuk-summary-list__row" *ngIf="!citizenshipJourney">
        <dt class="govuk-summary-list__key">Location</dt>
        <dd class="govuk-summary-list__value">
          <p>{{ address?.address.address1 }}</p>
          <p>{{ address?.address.address2 }}</p>
          <p>{{ address?.address.address4 }}</p>
          <p>{{ address?.address.address5 }}</p>
          <p>{{ address?.address.postcode }}</p>
        </dd>
      </div>

      <div class="govuk-summary-list__row" *ngIf="citizenshipJourney">
        <dt class="govuk-summary-list__key">Location</dt>
        <dd class="govuk-summary-list__value">
          <p *ngIf="address?.address?.address1">{{ address?.address.address1 }}</p>
          <p *ngIf="address?.address?.address2">{{ address?.address.address2 }}</p>
          <p *ngIf="address?.address?.address4">{{ address?.address.address4 }}</p>
          <p *ngIf="address?.address?.address5">{{ address?.address.address5 }}</p>
          <p *ngIf="address?.address?.postcode">{{ address?.address.postcode }}</p>
        </dd>
      </div>

    </dl>
  </div>
</div>
